<template>
    <div class="p-grid data-table data-table-list">
        <Toast />
        <div class="p-col-12">
            <div class="card card-w-title">
                <DataTable :value="dataTableUsers" class="p-datatable-responsive" :selection.sync="dataTableSelectedUser" dataKey="email" :paginator="true" :rows="10" :filters="filters" :autoLayout="true">
                    <template #header>
                        <h2>My Contacts</h2>
                        <div class="search">
                            <span class="icon icon-search"></span>
                            <InputText class="search-input p-filter" type="text" v-model="filters['name']" placeholder="Search" />
                        </div>
                    </template>
                    <Column field="id" header="ID/Username" :sortable="true" filterMatchMode="contains">
                        <template #body="slotProps">
                            <span class="username">{{slotProps.data.username}}</span>
                            <span class="name">{{slotProps.data.name}}</span>
                        </template>
                    </Column>
                    <Column field="name" header="Email/Phone" :sortable="true" filterMatchMode="contains">
                        <template #body="slotProps">

                            <span class="email">{{slotProps.data.email}}</span>
                            <span class="phone">{{slotProps.data.phone}}</span>
                        </template>
                    </Column>
                    <Column field="kyc" header="KYC check" headerStyle="min-width: 90px" :sortable="true">
                        <template #body="slotProps">
                            <span class="kyc-check-table">{{ slotProps.data.kyc }}</span>
                        </template>
                    </Column>
                    <Column field="commissions" header="Commission from user" headerStyle="min-width: 90px" :sortable="true">
                        <template #body="slotProps">
                            <span class="commissions">{{ slotProps.data.commissions }}</span>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>

     
     
    </div>
</template>

<script>
import UserService from '../../service/UserService';
import KycService from '../../service/KycService';

export default {
	data() {
		return {
            filters: {},
			dataTableUsers: null,
			dataTableSelectedUser: null,
			layout: 'list',
			sortKey: null,
			sortOrder: null,
			sortField: null,
			kyc: {
				display: false,
				title: '',
			},
		
		}
	},
	memberService: null,
	created() {
		this.$store.commit('setPageTitle', {pageTitle: 'My Contacts'});
		this.userService = new UserService();
		this.kycService = new KycService();

	},
	mounted() {
		this.userService.getContacts().then(data => this.dataTableUsers = data);
	},
	methods: {
		onSortChange(event){
			const value = event.value.value;
			const sortValue = event.value;

			if (value.indexOf('!') === 0) {
				this.sortOrder = -1;
				this.sortField = value.substring(1, value.length);
				this.sortKey = sortValue;
			}
			else {
				this.sortOrder = 1;
				this.sortField = value;
				this.sortKey = sortValue;
			}
		},
		formatDate(date) {
			var d = new Date(date),
				month = "" + (d.getMonth() + 1),
				day = "" + d.getDate(),
				year = d.getFullYear(),
				hours = "" + d.getHours(),
				mins = "" + d.getMinutes();

			if (month.length < 2) month = "0" + month;
			if (day.length < 2) day = "0" + day;
			if (hours.length < 2) hours = "0" + hours;
			if (mins.length < 2) mins = "0" + mins;

			return [year, month, day].join("-") + " " + hours + ":" + mins;
		},
		toUpperCase(string) {
			return string.toUpperCase();
		},
	
	
	}
}
</script>

<style lang="scss" scoped>
    .p-column-filter {
        margin-top: .5em;
    }
</style>